<div class="utm-tag-input">
  <label for="utm-input" class="utm-tag-input__label">
    UTM Parameters
    <span class="utm-tag-input__optional">(Optional)</span>
  </label>

  <!-- Selected Count & Clear All -->
  @if (selectedParams().length > 0) {
    <div class="utm-tag-input__header">
      <span class="utm-tag-input__count">
        {{ selectedParams().length }} parameter{{
          selectedParams().length === 1 ? '' : 's'
        }}
        selected
      </span>
      <button
        type="button"
        class="utm-tag-input__clear-all"
        [disabled]="disabled()"
        (click)="clearAll()"
      >
        Clear all
      </button>
    </div>
  }

  <!-- Input Container -->
  <div
    class="utm-tag-input__container"
    [class.utm-tag-input__container--focused]="showSuggestions()"
    [class.utm-tag-input__container--disabled]="disabled()"
  >
    <!-- Input Field with Combobox -->
    <div class="utm-tag-input__input-wrapper">
      <input
        id="utm-input"
        type="text"
        class="utm-tag-input__input"
        aria-label="Search UTM parameters"
        aria-controls="utm-suggestions-list"
        autocomplete="off"
        aria-role="combobox"
        [value]="inputValue()"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [attr.aria-expanded]="showSuggestions()"
        [attr.aria-activedescendant]="
          highlightedIndex() >= 0 ? 'utm-suggestion-' + highlightedIndex() : ''
        "
        (input)="onInputChange($any($event.target).value)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (keydown)="onKeyDown($event)"
      />

      <!-- Suggestions Dropdown -->
      @if (showSuggestions() && filteredSuggestions().length > 0) {
        <div
          class="utm-tag-input__suggestions"
          id="utm-suggestions-list"
          role="listbox"
        >
          @for (
            param of filteredSuggestions();
            track trackByFullParam($index, param);
            let i = $index
          ) {
            <button
              type="button"
              class="utm-tag-input__suggestion"
              aria-role="option"
              [class.utm-tag-input__suggestion--highlighted]="isHighlighted(i)"
              [id]="'utm-suggestion-' + i"
              [attr.aria-selected]="isHighlighted(i)"
              [attr.aria-label]="param.type + ': ' + param.value"
              (mousedown)="addParam(param); $event.preventDefault()"
              (mouseenter)="highlightedIndex.set(i)"
            >
              <span
                class="utm-tag-input__suggestion-badge"
                [ngClass]="getTypeColor(param.type)"
              >
                {{ param.type }}
              </span>
              <span class="utm-tag-input__suggestion-value">{{
                param.value
              }}</span>
            </button>
          }
        </div>
      }
    </div>
  </div>

  <!-- Selected Tags -->
  @if (selectedParams().length > 0) {
    <div class="utm-tag-input__tags">
      @for (param of selectedParams(); track trackByFullParam($index, param)) {
        <span class="utm-tag" [ngClass]="getTypeColor(param.type)">
          <g99-icon-btn
            class="utm-tag__icon"
            [icon]="svgIcons.tag"
            [width]="12"
            [height]="12"
          />
          <span class="utm-tag__type">{{ param.type }}:</span>
          <span class="utm-tag__value">{{ param.value }}</span>
          <button
            type="button"
            class="utm-tag__remove"
            [attr.aria-label]="'Remove ' + param.type + ' ' + param.value"
            [disabled]="disabled()"
            (click)="removeParam(param)"
          >
            <g99-icon-btn [icon]="svgIcons.close" [width]="12" [height]="12" />
          </button>
        </span>
      }
    </div>
  }

  <!-- Helper Text -->
  <p class="utm-tag-input__help-text">
    Start typing to see suggestions. Use ↑↓ arrows to navigate, Enter to select,
    or click/tap.
  </p>
</div>
